import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const FanvueAlertBanner = () => {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);
  const isAdmin = user?.role === 'admin';

  useEffect(() => {
    if (!isAdmin) return;
    const load = () => axios.get(`${API_URL}/chatting/fanvue/status`).then(r => setStatus(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 300000);
    return () => clearInterval(t);
  }, [isAdmin]);

  if (!isAdmin || status?.status !== 'disconnected') return null;
  return (
    <div className="bg-red-600 text-white px-4 py-2.5 flex items-center justify-between gap-3 text-sm" data-testid="fanvue-disconnected-banner">
      <div className="flex items-center gap-2">
        <AlertTriangle className="w-4 h-4 shrink-0" />
        <span>Fanvue connection lost{status.disconnected_at ? ` since ${new Date(status.disconnected_at).toLocaleString()}` : ''}. Chatter stats and invoices are paused.</span>
      </div>
      <Link to="/chatting" className="underline font-semibold whitespace-nowrap" data-testid="fanvue-reconnect-link">Reconnect Fanvue</Link>
    </div>
  );
};
